import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=51b6f44b&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b6f44b')) {
      api.createRecord('51b6f44b', component.options)
    } else {
      api.reload('51b6f44b', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=51b6f44b&", function () {
      api.rerender('51b6f44b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mtGsiPAh5fBw/JS/comp/ErrorMessage.vue"
export default component.exports